export default __webpack_public_path__ + "static/media/Networking_placeholder.30938d3e.jpg";